




































import Vue from 'vue'
import UiFormField from '../UiFormField'
import UiTextarea from '../../UiTextarea'
export default Vue.extend({
  name: 'UiFormTextArea',
  components: {
    UiTextarea
  },
  extends: UiFormField
})
